export const noticeTableOption = {
    // 系统消息列表
    page: false,
    border: true,
    stripe: true,
    align: 'center',
    menuAlign:'center',
    menu: true,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [
    {
      label: 'Id',
      width: 100,
      prop: 'id',
      align: 'center',
      editVisdiplay: false,
    }, {
      label: '内容',
      width: 290,
      prop: 'noticeContent',
      align: 'center',
      type: 'textarea',
      span: 24,
      minRows: 12,
      rules: [{
        required: true,
        message: "请输入内容",
        trigger: "blur"
      }]
    }, {
      label: '类型',
      width: 140,
      prop: 'noticeType',
      align: 'center',
      editVisdiplay: false,
    }, {
      label: '链接',
      width: 290,
      prop: 'link',
      solt: true,
      align: 'left',
      span: 24,
      minRows: 12,
    }, {
      label: '接收者类型',
      width: 180,
      prop: 'noticeToTypeName',
      align: 'center',
      span: 24,
      editVisdiplay: false,
    }, {
      label: '接收者',
      width: 180,
      prop: 'noticeToName',
      solt: true,
      align: 'center',
      span: 24,
      editVisdiplay: false,
    }, {
      label: '关联事务ID',
      width: 160,
      prop: 'entity',
      solt: true,
      align: 'center',
      span: 24,
      editVisdiplay: false,
    },{
      label: '企业微信通知',
      width: 160,
      prop: 'isSendWxCpNews',
      solt: true,
      align: 'center',
      span: 24,
      // editVisdiplay: false,
      type: 'select',
      dicData: [{
        label: '是',
        value: true
      }, {
        label: '否',
        value: false
      }],
    }, {
      // type: 'datetime',
      // valueFormat: 'timestamp',
      // format: 'yyyy-MM-dd hh:mm:ss',
      label: '发送时间',
      prop: 'sentTime',
      width: 160,
      align: 'center',
      editVisdiplay: false,
    }]
}
